import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

import { devSearchSchemaFor } from "@/modules/dev/registry/previews";

export const Route = createFileRoute("/dev/availability-failure")({
  validateSearch: devSearchSchemaFor("availability-failure"),
  component: lazyRouteComponent(
    () => import("@/modules/coaching/booking/dev/AvailabilityFailurePreview"),
    "AvailabilityFailurePreview",
  ),
});
